import React from 'react';
import PropTypes, { string } from 'prop-types';
import { strings } from 'APP_ROOT/localization';
/*
  The CSS works best if the element is one of the last main child elements added to the DOM (literally, lower down the page)

  I prefer to use state for this.

  constructor(props) {
    this.state = {
      myModal: null
    }
  }

  showModal () {
      const dismissModal = () => {
          this.setState({myModal: null});
      };
      this.setState({
          orderInfoModal: (<ModalContainer title="Title bar title" onClickClose={dismissModal}>
              [Any content or component(s) here]
               <div className="actions">
                   <button className="destructive" onClick={dismissModal} >Cancel</button>
                   <button onClick={() => {console.log("Ok"); dismissModal();}} >Ok</button>
               </div>
          </ModalContainer>)
      });
  }

  render() {
      return (
          [Any content or compoent(s) here]
          {this.state.myModal}
      )
  }
*/
export class ModalContainer extends React.PureComponent {

    static propTypes = {
        smallDialogMode: PropTypes.bool, // default false (1000px max width), if true 34.375rem max width
        fillToMaxHeightPixels: PropTypes.number, // default false (shrink to fit content), if true then stretch to fit to a max value provided (set to pixels)
        onClickClose: PropTypes.func,
        title: PropTypes.string.isRequired
    }

    render() {

        if (!this.props.children) return null;

        let modalClassName = "modal2";
        if (this.props.smallDialogMode) modalClassName += " small-format";
        if (this.props.fillToMaxHeightPixels) modalClassName += " max-height";

        let closeButton = null;
        if (this.props.onClickClose) {
            closeButton = (
                <button>
                    <i className="material-icons" onClick={this.props.onClickClose}>clear</i>
                </button>
            );
        }

        return (
            <div className="modal2-container">
                <div className={modalClassName} style={this.props.fillToMaxHeightPixels ? {maxHeight: this.props.fillToMaxHeightPixels + "px"} : null}>
                    <header>
                        <span>
                            {this.props.title}
                        </span>
                        {closeButton}
                    </header>
                    <section className="modal2-inner-content">
                        {this.props.children}
                    </section>
                </div>
            </div>
        )
    }
}

export class ConfirmationDialog extends React.PureComponent {

    static propTypes = {
        title: PropTypes.string.isRequired,
        message: PropTypes.string.isRequired,
        cancelButtonAction: PropTypes.func.isRequired,
        cancelButtonTitle: PropTypes.string.isRequired,
        hideHeaderCloseButton: PropTypes.bool, // set to true when you want to force user to make a choice
        submitButtonAction: PropTypes.func.isRequired,
        submitButtonTitle: PropTypes.string.isRequired
    }

    render () {
        return (
            <ModalContainer title={this.props.title} onClickClose={this.props.hideHeaderCloseButton ? null : this.props.cancelButtonAction} smallDialogMode={true} >
                <div className="message">
                    {this.props.message}
                </div>
                <div className="actions">
                    <button className="destructive" onClick={this.props.cancelButtonAction} >
                        {this.props.cancelButtonTitle}
                    </button>
                    <button onClick={this.props.submitButtonAction} >
                        {this.props.submitButtonTitle}
                    </button>
                </div>
            </ModalContainer>
        )
    }
}

export class LegacyConfirmDialog extends React.PureComponent {
    static propTypes = {
        // The following props mimic components/common/ConfirmDialog
        title: PropTypes.string,
        message: PropTypes.bool,
        isOpen: PropTypes.bool.isRequired, 
        onOk: PropTypes.func.isRequired,
        onCancel: PropTypes.func.isRequired,
        onDismiss: PropTypes.func.isRequired,
    
        // Optional props to leverage Modal2 during partial transition
        smallDialogMode: PropTypes.bool,
        hideHeaderCloseButton: PropTypes.bool, // set to true when you want to force user to make a choice
        cancelButtonTitle: PropTypes.string, // override "Cancel" default
        submitButtonTitle: PropTypes.string, // override "Ok" default
    }

    render () {

        if (!this.props.isOpen) { return null }

        let title = this.props.title || ""; // title is required for Modal2
        let smallDialogMode = this.props.smallDialogMode === false ? false : true; // default to true
        let hideHeaderCloseButton = this.props.hideHeaderCloseButton || false; // default to false, sanitize undefined to false
        let cancelButtonTitle = this.props.cancelButtonTitle || strings.app_cancel;
        let submitButtonTitle = this.props.submitButtonTitle || strings.app_ok;

        return (
            <ModalContainer title={title} onClickClose={hideHeaderCloseButton ? null : this.props.onDismiss} smallDialogMode={smallDialogMode} >
                {this.props.children ?
                    this.props.children
                :
                    <div className="message">
                        {this.props.message}
                    </div>
                }

                <div className="actions">
                    <button className="destructive" onClick={this.props.onCancel} >
                        {cancelButtonTitle}
                    </button>
                    <button onClick={this.props.onOk} >
                        {submitButtonTitle}
                    </button>
                </div>
            </ModalContainer>
        )
    }
}